import React, { useState, useEffect } from "react";
import styles from "./Einwilligung.module.css";
import Button from "@mui/material/Button";
import Spacer from "../../components/Spacer/Spacer";

// Nur diese Keys werden durch die Einwilligung geschützt (siehe Kontakt.jsx: dort
// werden Name/E-Mail/Termin nur bei erteilter Einwilligung im LocalStorage zwischen-
// gespeichert). Bei Ablehnung werden ausschließlich diese Keys gelöscht - NICHT der
// komplette LocalStorage, da dort z.B. auch der Foodosia-Speiseplan liegt
// (foodosia-daily-plan:*, siehe dailyMenuApi.js), der nichts mit dieser Einwilligung
// zu tun hat und durch eine Ablehnung nicht verloren gehen darf.
const CONSENT_GATED_STORAGE_KEYS = ["form_data", "timeexpired", "last_submit"];

function clearConsentGatedStorage() {
  CONSENT_GATED_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

function Einwilligung() {
  // Status der Einwilligung aus dem LocalStorage initial laden
  const [consent, setConsent] = useState(() => {
    const saved = localStorage.getItem("user_consent");
    // Konvertiert gespeicherte Werte "true"/"false" in Boolean, sonst null
    return saved === "true" ? true : saved === "false" ? false : null;
  });

  // Effekt: Wenn Einwilligung abgelehnt wird, die davon abhängigen LocalStorage-Daten löschen
  useEffect(() => {
    if (consent === false) {
      clearConsentGatedStorage();
    }
  }, [consent]);

  // Funktion zur Verarbeitung der Einwilligung oder Ablehnung
  const handleConsent = (value) => {
    setConsent(value);
    localStorage.setItem("user_consent", value);
    if (!value) {
      // Bei Ablehnung: nur die durch die Einwilligung geschützten Daten löschen
      clearConsentGatedStorage();
    }
  };

  return (
    <div className={styles.einwilligungWrapper}>
      {/* Titelbereich der Seite */}
      <h1 className={styles.einwilligungTitle}>
        Einwilligung zur Datenspeicherung
      </h1>

      {/* Erklärung, warum Daten gespeichert werden und Hinweis auf Datenschutzerklärung */}
      <p className={styles.einwilligungText}>
        Indem du dich registrierst, erklärst du dich damit einverstanden, dass
        wir deine angegebenen Daten (wie Name, E-Mail, Telefonnummer,
        Eventdetails) im LocalStorage deines Browsers speichern.
        <br />
        Dadurch können wir das Formular für dich vorausfüllen, falls du es noch
        nicht abgeschickt hast oder die Seite neu lädst.
        <br />
        Das erhöht deine Bequemlichkeit, da du deine Angaben nicht erneut
        eingeben musst.
        <br />
        Lies dir unsere{" "}
        <a href="/datenschutzerklaerung">Datenschutzerklärung</a> und unsere{" "}
        <a href="/agb">allgemeinen Geschäftsbedingungen</a> für weitere
        Informationen durch.
      </p>

      {/* Buttons für Einwilligen oder Ablehnen */}
      <div className={styles.einwilligungButtons}>
        <Button
          fullWidth
          variant="contained"
          disabled={consent === true} // Button deaktivieren, wenn bereits eingewilligt
          onClick={() => handleConsent(true)}
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            fontWeight: 500,
            textAlign: "center",
            fontSize: "16px",
            border: "none",
            boxShadow: "none",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "var(--primary-color-hover)",
              border: "none",
              boxShadow: "none",
              color: "#fff",
            },
          }}
        >
          Einwilligen
        </Button>

        <Button
          fullWidth
          variant="contained"
          disabled={consent === false} // Button deaktivieren, wenn bereits abgelehnt
          onClick={() => handleConsent(false)}
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            fontWeight: 500,
            textAlign: "center",
            fontSize: "16px",
            border: "none",
            boxShadow: "none",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "var(--primary-color-hover)",
              border: "none",
              boxShadow: "none",
              color: "#fff",
            },
          }}
        >
          Ablehnen
        </Button>
      </div>

      {/* Dynamische Statusanzeige je nach Auswahl */}
      {consent === true && (
        <p className={styles.einwilligungStatus}>
          Du hast der Speicherung deiner Daten zugestimmt.
        </p>
      )}
      {consent === false && (
        <p className={styles.einwilligungStatusDeclined}>
          Du hast die Speicherung deiner Daten abgelehnt. Es werden keine Daten
          gespeichert.
        </p>
      )}
      <Spacer space={"70px"} />
    </div>
  );
}

export default Einwilligung;
